
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/customization/css-theme-variables/configuration",
      function () {
        return require("private-next-pages/material-ui/customization/css-theme-variables/configuration.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/customization/css-theme-variables/configuration"])
      });
    }
  